import { useState, useContext, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import UserContext from '../store/user-context';
import TriviaContext from '../store/trivia-context';

import Button from '../components/ui/Button';
import Loading from '../components/layout/Loading';

// IMAGES
import imgTrophyPass from '../assets/ic_trophy.png';
import imgTrophyFail from '../assets/fail_trophy.png';

import classes from './ResultPage.module.scss';
import Title from '../components/ui/Title';

import { AdMob } from '@capacitor-community/admob';

function ResultPage() {
    const triviaCtx = useContext(TriviaContext);
    const userCtx = useContext(UserContext);
    const [result, setResult] = useState();
    const [score, setScore] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    const showInterstitialAd = async () => {
        const options = {
            adId: 'ca-app-pub-4470794203154587/8278395095',
        };
        await AdMob.prepareInterstitial(options);
        await AdMob.showInterstitial();
    }

    const generateResult = async () => {
        const score = triviaCtx.triviaStatus.reduce((accumulator, currentValue) => {
            return accumulator + (currentValue.result ? 1 : 0);
        }, 0);

        setScore(score);

        if (score > 3) {
            setResult('Level Up!');

            await userCtx.updateScore(score, triviaCtx.movieCategory);
        } else {
            setResult('You Failed!');
        }
    }

    useEffect(() => {
        showInterstitialAd();

        if (!triviaCtx.movieCategory) {
            history.replace("/HomePage");
        } else {
            generateResult();

            const loadingTimer = setTimeout(() => {
                if (isLoading) {
                    setIsLoading(false);
                }
                clearTimeout(loadingTimer);
            }, 4000);
        }
        return () => {
            setIsLoading(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function gotoHomeHandler() {
        triviaCtx.resetTriviaStatus();
        history.replace('HomePage');
    }

    const gotoLeaderboardHandler = () => {
        history.replace('Leaderboard');
    }

    const playNextLevelHandler = () => {
        triviaCtx.resetTriviaStatus();
        history.push("/TriviaPage");
    }

    const imageLoaded = () => {
        setIsLoading(false);
    }

    return (
        <div className={classes.result}>

            {isLoading && <Loading />}

            <Title>
                {result}
            </Title>

            <h2>YOUR SCORE</h2>
            <div className={classes['result__score']}>
                {score} / {triviaCtx.triviaStatus.length}
            </div>
            <br />
            <h2>TOTAL SCORE</h2>
            <div className={classes['result__score']}>
                {userCtx.score + (score > 3 ? score : 0)}
            </div>
            <br />
            <figure className={classes['result__trophy']}>
                <img src={score > 3 ? imgTrophyPass : imgTrophyFail} className={classes['result__trophy--img']} alt="movie trivia trophy" onLoad={imageLoaded} />
            </figure>

            <Button onBtnClick={playNextLevelHandler}> {(score > 3 ? 'Play Next Level' : 'Play Again')}</Button>
            <br />
            <Button onBtnClick={gotoLeaderboardHandler} >Leaderboard</Button>
            <br />
            <Button onBtnClick={gotoHomeHandler}>Home</Button>
            <br /><br />
            <br /><br />
        </div>
    )
}

export default ResultPage
